import { FormEvent, useMemo, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { caseAccessHttp } from '@/services/caseAccess'

export default function CaseInviteRedemptionPage() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const token = useMemo(() => params.get('token') ?? '', [params])
  const [email, setEmail] = useState('')
  const [redemptionId, setRedemptionId] = useState<string | null>(null)
  const [otp, setOtp] = useState('')
  const [busy, setBusy] = useState(false)
  const [message, setMessage] = useState('Enter the email address that received this invitation.')

  const begin = async (event: FormEvent) => {
    event.preventDefault(); setBusy(true)
    try {
      const result = await caseAccessHttp.begin(token, email, 'RETURN_PREPARATION')
      setRedemptionId(result.redemption_id)
      setMessage(result.message)
    } catch { setMessage('The request could not be completed. Check the link and try again.') } finally { setBusy(false) }
  }
  const verify = async (event: FormEvent) => {
    event.preventDefault(); if (!redemptionId) return; setBusy(true)
    try {
      const verified = await caseAccessHttp.verifyOtp(redemptionId, otp)
      if (verified.status !== 'VERIFIED') { setMessage('Verification is still pending. Check the code and try again.'); return }
      const completion = await caseAccessHttp.complete(redemptionId)
      caseAccessHttp.store(completion)
      navigate(`/case-access/${completion.case_id}`, { replace: true })
    } catch { setMessage('The invitation could not be completed. It may be expired, revoked, or already used.') } finally { setBusy(false) }
  }

  return <main className="flex min-h-screen items-center justify-center bg-background p-4"><section className="card w-full max-w-md space-y-4 p-6" aria-labelledby="invite-heading"><div><h1 id="invite-heading" className="text-xl font-semibold">Secure case invitation</h1><p className="mt-2 text-sm text-text-secondary" role="status">{message}</p></div>{!redemptionId ? <form className="space-y-4" onSubmit={begin}><label className="block text-sm">Invitation email<input className="input mt-1 w-full" type="email" autoComplete="email" required value={email} onChange={event => setEmail(event.target.value)} /></label><button className="btn btn-primary w-full" disabled={busy || !token}>Send verification code</button></form> : <form className="space-y-4" onSubmit={verify}><label className="block text-sm">Six-digit verification code<input className="input mt-1 w-full" inputMode="numeric" autoComplete="one-time-code" pattern="[0-9]{6}" maxLength={6} required value={otp} onChange={event => setOtp(event.target.value.replace(/\D/g, ''))} /></label><button className="btn btn-primary w-full" disabled={busy || otp.length !== 6}>Verify and open case</button></form>}<p className="text-xs text-text-secondary">The link does not grant access by itself. Access is limited to the invited case and expires automatically.</p></section></main>
}
